// Layer filter shared by the Elements and Plants tabs (v1 parity): '' = all
// layers, NO_LAYER = elements without a (known) layer, else a layer id.

import { esc } from './html';

export const NO_LAYER = '__none__';

// Drop a stale filter (its layer was deleted) back to "All layers".
export function activeLayerFilter(state, value) {
  if (!value || value === NO_LAYER) return value || '';
  return state.layers.some((l) => l.id === value) ? value : '';
}

export function matchesLayer(el, filter, state) {
  if (!filter) return true;
  const layer = el.data?.layer;
  const known = layer && state.layers.some((l) => l.id === layer);
  return filter === NO_LAYER ? !known : layer === filter;
}

export function layerFilterHtml(state, kind, value) {
  if (!state.layers.length) return '';
  const opts = [['', 'All layers'], [NO_LAYER, 'No layer'], ...state.layers.map((l) => [l.id, l.name])]
    .map(([id, name]) => `<option value="${esc(id)}" ${value === id ? 'selected' : ''}>${esc(name)}</option>`).join('');
  return `<select class="pl2-input pl2-filter" data-pl2="${kind}" title="Filter by layer">${opts}</select>`;
}
